import React, { useContext } from "react";
import { ResultsTournamentContext } from "@state/context/results";
import EventGroup from "./EventGroup";

export default function ResultsTableBody() {
	const tournament = useContext(ResultsTournamentContext);

	return (
		<tbody className="table--results__body">
			{[...tournament.events].map((eventGroup) => (
				<EventGroup
					key={`${tournament.id}-${eventGroup[0]}`}
					eventGroup={eventGroup}
				/>
			))}
		</tbody>
	);
}
